"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var actions = {
    "management/setLastRemovedCabin": function (_a, index) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                commit("management/setLastRemovedCabin", index);
                return [2 /*return*/];
            });
        });
    },
    "management/removeCabinByIndex": function (_a, index) {
        var commit = _a.commit, dispatch = _a.dispatch, getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var activeCabinIndex, maxCabinIndex, cabinReset;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (getters["management/cabinCount"] <= 1 ||
                            getters["management/cabinCount"] < index + 1) {
                            return [2 /*return*/];
                        }
                        activeCabinIndex = getters["management/activeCabinIndex"];
                        if (!(activeCabinIndex === index)) return [3 /*break*/, 4];
                        maxCabinIndex = getters["management/cabinCount"] - 1;
                        if (!(maxCabinIndex === index)) return [3 /*break*/, 2];
                        return [4 /*yield*/, dispatch("management/setActiveCabinByIndex", index - 1)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, dispatch("management/setActiveCabinByIndex", index + 1)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        cabinReset = getters["management/basket"][index];
                        commit("management/setLastRemovedCabin", index);
                        commit("management/removeCabinByIndex", index);
                        dispatch(cabinReset + "/resetStores");
                        return [2 /*return*/];
                }
            });
        });
    },
    "management/addCabin": function (_a) {
        var commit = _a.commit, dispatch = _a.dispatch, getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var newCabin;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (getters["management/cabinCount"] === 4) {
                            return [2 /*return*/];
                        }
                        newCabin = getters["management/firstUnusedCabin"];
                        if (!newCabin) {
                            return [2 /*return*/];
                        }
                        commit("management/addCabin", newCabin);
                        if (!getters["currentCabin/wizard/allValid"]) return [3 /*break*/, 2];
                        return [4 /*yield*/, dispatch("management/setActiveCabin", newCabin)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    },
    "management/setActiveCabinByIndex": function (_a, index) {
        var commit = _a.commit;
        commit("management/setActiveCabinByIndex", index);
    },
    "management/setActiveCabin": function (_a, cabin) {
        var dispatch = _a.dispatch, getters = _a.getters;
        return __awaiter(this, void 0, void 0, function () {
            var basket, cabinIndex;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        basket = getters["management/basket"];
                        cabinIndex = lodash_1.indexOf(basket, cabin);
                        if (!(cabinIndex !== -1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, dispatch("management/setActiveCabinByIndex", cabinIndex)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    },
    "management/checkAndResetCabinPriceModel": function (_a) {
        var commit = _a.commit, getters = _a.getters;
        var activeCabinKey = getters["management/activeCabinKey"];
        var isPremiumSelected = getters[activeCabinKey + "/cabins/isPremiumSelected"];
        var isPremiumAISelected = getters[activeCabinKey + "/cabins/isPremiumAISelected"];
        var isVarioAISelected = getters[activeCabinKey + "/cabins/isVarioAISelected"];
        var inactiveCabins = getters["management/basket"];
        inactiveCabins = lodash_1.without(inactiveCabins, activeCabinKey);
        for (var _i = 0, inactiveCabins_1 = inactiveCabins; _i < inactiveCabins_1.length; _i++) {
            var cabin = inactiveCabins_1[_i];
            if ((isPremiumSelected !== getters[cabin + "/cabins/isPremiumSelected"] ||
                isPremiumAISelected !==
                    getters[cabin + "/cabins/isPremiumAISelected"] ||
                isVarioAISelected !== getters[cabin + "/cabins/isVarioAISelected"]) &&
                getters[cabin + "/cabins/selectedMainCabinCategory"] !== null) {
                commit(cabin + "/cabins/REMOVE_USER_SELECTIONS");
                commit(cabin + "/cabins/SET_CABIN_AUTO_RESET", true);
                commit(cabin + "/wizard/setStepIncompleted", "bookingCabinCategory");
                commit(activeCabinKey + "/wizard/setStepIncompleted", "bookingCabinCategory");
            }
        }
    },
    "management/handlePriceDiffer": function (_a, messages) {
        var commit = _a.commit, dispatch = _a.dispatch, getters = _a.getters;
        var cabinPaxes = [];
        var cabinPricings = {};
        var cabins = getters["management/basket"];
        for (var _i = 0, cabins_1 = cabins; _i < cabins_1.length; _i++) {
            var cabin = cabins_1[_i];
            var numPaxes = getters[cabin + "/pax/all"].length;
            var paxList = new Array(numPaxes);
            var index = 0;
            while (index < numPaxes) {
                paxList[index++] = cabin;
            }
            cabinPaxes.push.apply(cabinPaxes, paxList);
            cabinPricings[cabin] = [];
        }
        var paxes = getters["apiBookData"].paxe;
        var services = getters["apiBookData"].services;
        for (var _b = 0, _c = messages.messages; _b < _c.length; _b++) {
            var message = _c[_b];
            var service = services[message.service];
            var serviceType = messages.serviceType === 'flex' && service.type === 'AIR' ? 'FLX' : service.type;
            var pricing = {
                type: serviceType,
                price: message.price.after,
                priceOld: message.price.before,
            };
            var paxCabin = cabinPaxes[service.paxIds[0] - 1];
            cabinPricings[paxCabin].push(pricing);
        }
        for (var _d = 0, cabins_2 = cabins; _d < cabins_2.length; _d++) {
            var cabin = cabins_2[_d];
            if (cabinPricings[cabin].length > 0) {
                dispatch(cabin + "/handlePriceDiffer", cabinPricings[cabin]);
            }
        }
        // remove the API error
        commit("booking/general/SET_BOOK_ERROR", null, { root: true });
    },
    "management/resetFlex": function (_a, reset) {
        var commit = _a.commit;
        commit("management/resetFlex", reset);
    },
};
var getters = {
    "management/activeCabinKey": function (state) {
        return state.activeCabinKey;
    },
    "management/activeCabinIndex": function (state) {
        return lodash_1.indexOf(state.basket, state.activeCabinKey);
    },
    "management/basket": function (state) {
        return state.basket;
    },
    "management/cabinCount": function (state) {
        return state.basket.length;
    },
    "management/cabinPriceDiffers": function (_state, getters) {
        var priceDiffers = [];
        var basket = getters["management/basket"];
        for (var _i = 0, basket_1 = basket; _i < basket_1.length; _i++) {
            var cabin = basket_1[_i];
            priceDiffers.push(getters[cabin + "/priceDiffers"]);
        }
        return priceDiffers;
    },
    "management/firstUnusedCabin": function (_state, getters) {
        var basket = getters["management/basket"];
        for (var _i = 0, _a = ["cabin1", "cabin2", "cabin3", "cabin4"]; _i < _a.length; _i++) {
            var cabin = _a[_i];
            if (lodash_1.indexOf(basket, cabin) === -1) {
                return cabin;
            }
        }
        return null;
    },
    "management/resetFlex": function (state) {
        return state.resetFlex;
    },
    "management/lastRemovedCabin": function (state) {
        return state.lastRemovedCabin;
    },
};
var mutations = {
    "management/removeCabinByIndex": function (state, index) {
        state.basket = lodash_1.without(state.basket, state.basket[index]);
    },
    "management/setActiveCabinByIndex": function (state, index) {
        if (index < 0 ||
            getters["management/cabinCount"] > index + 1) {
            return;
        }
        state.activeCabinKey = state.basket[index];
    },
    "management/addCabin": function (state, cabin) {
        state.basket.push(cabin);
    },
    "management/resetFlex": function (state, reset) {
        state.resetFlex = reset;
    },
    "management/setLastRemovedCabin": function (state, index) {
        state.lastRemovedCabin = index;
    },
};
exports.default = {
    actions: actions,
    getters: getters,
    mutations: mutations,
};
//# sourceMappingURL=cabinManagement.js.map